import React from "react"

const GradeDisplay = ({ score, pointsPossible, percentage, grade }) => {
  const getColorClass = (pct) => {
    if (pct >= 90) return "text-green-600"
    if (pct >= 80) return "text-blue-600"
    if (pct >= 70) return "text-yellow-600"
    if (pct >= 60) return "text-orange-600"
    return "text-red-600"
  }

  const colorClass = percentage != null ? getColorClass(percentage) : "text-gray-600"

  // Calculate stroke dasharray for circular progress
  const radius = 14
  const circumference = 2 * Math.PI * radius
  const progress = percentage != null ? (percentage / 100) * circumference : 0

  return (
    <div className="flex items-center gap-2">
      {percentage != null && (
        <div className="relative w-9 h-9">
          <svg className="w-full h-full transform -rotate-90" viewBox="0 0 36 36">
            <circle
              cx="18"
              cy="18"
              r={radius}
              fill="none"
              stroke="currentColor"
              strokeWidth="3"
              className="text-gray-200"
            />
            <circle
              cx="18"
              cy="18"
              r={radius}
              fill="none"
              stroke="currentColor"
              strokeWidth="3"
              strokeDasharray={circumference}
              strokeDashoffset={circumference - progress}
              strokeLinecap="round"
              className={colorClass}
            />
          </svg>
          <span className={`absolute inset-0 flex items-center justify-center text-xs font-medium ${colorClass}`}>
            {Math.round(percentage)}
          </span>
        </div>
      )}

      <div className="text-right">
        <span className={`text-sm font-medium ${colorClass}`}>
          {grade || (score != null && pointsPossible != null ? `${score}/${pointsPossible}` : score)}
        </span>
      </div>
    </div>
  )
}

export default GradeDisplay
